import React, { useRef, useEffect } from 'react';
import { View, StyleSheet, Animated } from 'react-native';
const styles = StyleSheet.create({
    progressBar: {
        backgroundColor: '#E4E9F2',
        borderRadius: 5,
        flexDirection: 'row',
        height: 3,
        width: '100%',
    },
});
function ProgressBar(props) {
    const animation = useRef(new Animated.Value(0));
    const progressInPercentage = (props.progress * 100) / props.finalValue;
    useEffect(() => {
        Animated.timing(animation.current, {
            useNativeDriver: false,
            toValue: progressInPercentage,
            duration: 100,
        }).start();
    }, [progressInPercentage]);
    const width = animation.current.interpolate({
        inputRange: [0, 100],
        outputRange: ['0%', '100%'],
        extrapolate: 'clamp',
    });
    return (<View style={styles.progressBar}>
      <Animated.View style={[{ backgroundColor: '#35C895', width }]}/>
    </View>);
}
export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map